import { client } from '@repo/shared-kit/utils';
// @ts-expect-error -- file is not typed
import ENV from 'receivable-invoices-js/config/environment';
import { apiBaseURL } from 'receivable-invoices-js/constants/hosts';
import { waitForFetch } from 'receivable-invoices-js/utils/wait-for-fetch';

const headers: Record<string, string> = {};

const env = ENV as { deployTarget?: string; stagingAccessToken?: string };

if (typeof env !== 'undefined' && env.deployTarget === 'staging' && env.stagingAccessToken) {
  headers['X-Qonto-Staging-Token'] = env.stagingAccessToken;
}

client.init({
  baseURL: apiBaseURL,
  headers,
  fetch: (...args) => waitForFetch(fetch(...args)),
});
